import { LocationUtilities, SiteUtilities, GA4Utilities } from './index';

var UIAnimations = function () {
  /*
  * Issue: Partner signup form is overlapped with footer when it's content is lengthy in height
  * Solution: Since partner form is positioned as absolute
  * When the form height is higher than it's parent height (.partner-page-container)
  * We need to calculate extra height occupied by the form then add it to existing padding bottom value
  */
  var $partnerPageContainer = jQuery('.partner-page-container');
  if ($partnerPageContainer.length) {
    jQuery(window).on('load', function () {
      var partnerFormExtraHeight = jQuery('.partners-form-layout').height() - $partnerPageContainer.height();
      if (partnerFormExtraHeight > 30) {
        var partnerContainerPaddingBottom = parseInt($partnerPageContainer.css('padding-bottom'));
        $partnerPageContainer.css('padding-bottom', `${partnerContainerPaddingBottom + partnerFormExtraHeight}px`);
      }
    });
  }

  jQuery('.name-field input').on('click focus', function () {
    jQuery(this).parent().parent('.form-field').addClass('active');
  });

  jQuery('.name-field input').on('blur', function () {
    jQuery(this).parent().parent('.form-field').removeClass('active');
  });

  jQuery('.terms-text-control').focus(function () {
    jQuery('.no-card').css({ opacity: 0 });
  });

  jQuery('.terms-text-control').blur(function () {
    if (!jQuery(this).val()) {
      jQuery('.no-card').css({ opacity: 1 });
    }
  });

  /*
  * Based on the click, add classname 'active' for the current field
  * and its parent element. So that the placeholder text will get
  * animated to the top.
  */
  jQuery('.form-field input, .form-field textarea, .form-field select').on('click', function () {
    jQuery(this).addClass('field-fix');
    jQuery(this).parent('.form-field').addClass('active');
  });

  jQuery('.form-field input, .form-field textarea').on('keyup', function (e) {
    var code = e.keyCode || e.which;
    if (code === 9) {
      jQuery(this).addClass('field-fix').parent('.form-field').addClass('active');
    }
  });

  /*
  * If the input/textarea has value, the placeholder text will remain in
  * the top position with the help of classname 'placeholder-fix'.
  */
  jQuery('.form-field input, .form-field textarea').on('focus blur change', function () {
    var value = jQuery(this).val();
    jQuery(this).parent('.form-field').addClass('active');

    if (value != null && value !== '') {
      jQuery(this).addClass('field-fix').parent().find('.form-placeholder').addClass('placeholder-fix');
    } else {
      jQuery(this).removeClass('field-fix').parent().find('.form-placeholder').removeClass('placeholder-fix');
    }
  });

  jQuery('.form-field input, .form-field textarea, .form-field select').on('blur', function () {
    jQuery(this).parent('.form-field').removeClass('active');

    if (jQuery(this).children('option').is(':selected')) {
      jQuery(this).addClass('field-fix').parent().find('.form-placeholder').addClass('placeholder-fix');
    }

    var selectedValue = jQuery(this).children('option:selected').val();
    if (selectedValue === '') {
      jQuery(this).removeClass('field-fix').parent().find('.form-placeholder').removeClass('placeholder-fix');
    }
  });

  jQuery('.data-link').on('click', function () {
    jQuery(this).addClass('active');
    if (localStorage.getItem('webinar-subscribed') == null) {
      jQuery('#webinar_subscribe_form').modal('show');
    } else {
      jQuery(this).removeClass('active');
      window.location = jQuery(this).data('href');
    }
  });

  jQuery('.form-field select').on('focus change', function () {
    jQuery(this).parent('.form-field').addClass('active');
    jQuery(this).css('opacity', '1');

    if (jQuery(this).children('option').is(':selected')) {
      jQuery(this).parent().find('.form-placeholder').addClass('placeholder-fix');
    } else {
      jQuery(this).removeClass('field-fix').parent().find('.form-placeholder').removeClass('placeholder-fix');
    }
  });

  // Form Company name mapping to Domain Name
  const formClassnames = ['fsales-signupform', 'fservice-signup-form', 'fdesk-signupform'];
  formClassnames.map(function (formClassname) {
    jQuery('.' + formClassname).find('.company-form').on('keyup keydown keypress change', function (ev) {
      var domainName = jQuery(this).val().toLowerCase().replace(/[^a-zA-Z0-9-]/g, '');
      if (domainName.trim() !== '') {
        jQuery('.domain-form').val(domainName).addClass('field-fix');
        jQuery('.domain-form').parent().find('.form-placeholder').addClass('placeholder-fix');
      } else {
        jQuery('.domain-form').val('').removeClass('field-fix');
        jQuery('.domain-form').parent().find('.form-placeholder').removeClass('placeholder-fix');
      }
    });
  });
};

var FieldValidation = ($ = jQuery) => {
  /*
  * FieldValidation will validate each field through out the product.
  * If new field is added in the form and have to be validate, then add
  * it into the variable name 'formFieldName'.
  */

  var formFieldName = $('.form-field [data-required], .form-field [data-first-name-required], .form-field [data-last-name-required], .form-field [data-select-required], .form-field [data-select-required-override], .form-field [data-company-required], .form-field [data-employees-required], .form-field [data-department-required], .form-field [data-joblevel-required], .form-field [data-companyindustry-required], .form-field [data-website-required], .form-field [data-message-required], .form-field [data-domain-required], .form-field [data-url-required], .form-field [data-country-required], .form-field [data-phone-required], .form-field [data-signup-domain-required], .form-field [data-name-validate], .form-field [data-checkbox-required], .form-field [data-non-alphabets-validate]');

  $(formFieldName).each(function () {
    $(this).rules('add', {
      required: true
    });
  });

  $('.fsales-signupform .form-field [name="domain"]').each(function () {
    $(this).rules('add', {
      fsalesDomainAvailable: true,
      subdomain: true,
      minlength: 3,
      maxlength: 25
    });
  });

  /* domain validation check */
  const validateDomain = function (value, element) {
    const domainApiValidateEndpoint = $(element).parents('form').data('domain-validation-url');
    const settings = {
      async: false,
      crossDomain: true,
      url: domainApiValidateEndpoint,
      type: 'GET',
      data: {
        domain: value
      }
    };
    return $.ajax(settings);
  };
  const product = $('body').data('product-name');
  if (product) {
    const domainAvailableErrorMsg = {
      fsales: $('.fsales-signupform').attr('data-domain-availability-error'),
      fdesk: 'Domain Name does not exist'
    };
    let returnValue = false;
    $.validator.addMethod('fsalesDomainAvailable', function (value, element) {
      validateDomain(value, element)
        .done(function (response, textStatus, jqXHR) {
          const status = jqXHR.status;
          const isSuccess = (status >= 200 && status < 300) || (status === 304);
          if (!isSuccess) {
            domainAvailableErrorMsg['fsales'] = 'Error contacting API: ' + status;
          }
          returnValue = response.is_available;

          // Pushing tvc_domain_taken event in dataLayer to ga, if domain name already exists
          if (!returnValue) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'tvc_domain_taken'
            });
          }
        });
      return returnValue;
    }, domainAvailableErrorMsg['fsales']);
    $.validator.addMethod('fdeskDomainAvailable', function (value, element) {
      validateDomain(value, element)
        .fail((jqXHR, textStatus) => {
          const status = jqXHR.status;
          if (status === 400) {
            domainAvailableErrorMsg['fdesk'] = 'Error contacting API: ' + status;
            returnValue = false;
          } else if (status === 409) {
            returnValue = true;
          }
        });
      return returnValue;
    }, domainAvailableErrorMsg['fdesk']);
  }
  /*
  * Freshsales Signup Custom Validation Checks
  * Impact Fields: Domain, Company, Phone
  */

  // let domainAvailableErrorMsg = 'Sorry this Domain Name already exists';
  // let apiDomain = 'https://login.freshsales.io';

  // $.validator.addMethod('domainAvailable', function (value) {
  //   let returnValue = false;
  //   let settings = {
  //     'async': false,
  //     'crossDomain': true,
  //     'url': apiDomain + '/domain_available',
  //     'type': 'GET',
  //     'data': {
  //       'domain': value
  //     }
  //   };

  //   $.ajax(settings).done(function (response, textStatus, jqXHR) {
  //     let status = jqXHR.status;
  //     let isSuccess = (status >= 200 && status < 300) || (status === 304);
  //     if (!isSuccess) {
  //       domainAvailableErrorMsg = 'Error contacting API: ' + status;
  //     }
  //     returnValue = response.is_available;
  //   });
  //   return returnValue;
  // }, domainAvailableErrorMsg);

  // let fdeskdomainAvailableErrorMsg = 'Domain Name does not exist';
  // let fdeskApiDomain = 'https://freshsignup.freshdesk.com';
  // $.validator.addMethod('fdeskDomainAvailable', function (value) {
  //   let returnValue = false;
  //   let settings = {
  //     'async': false,
  //     'crossDomain': true,
  //     'url': fdeskApiDomain + '/accounts/signup_validate_domain.json',
  //     'type': 'GET',
  //     'data': {
  //       'domain': value
  //     }
  //   };
  //   $.ajax(settings).done(function (response, textStatus, jqXHR) {
  //     let status = jqXHR.status;
  //     if ((status >= 200 && status < 300) || (status === 304)) {
  //       returnValue = false;
  //     }
  //   }).fail((jqXHR, textStatus) => {
  //     let status = jqXHR.status;
  //     if (status === 400) {
  //       fdeskdomainAvailableErrorMsg = 'Error contacting API: ' + status;
  //       returnValue = false;
  //     }
  //     if (status === 409) {
  //       returnValue = true;
  //     }
  //   });
  //   return returnValue;
  // }, fdeskdomainAvailableErrorMsg);

  $.validator.addMethod('subdomain', function (value, element) {
    const re = /[^a-zA-Z0-9-]/;
    return this.optional(element) || !re.test(value.replace(/^\s*|\s*$/g, ''));
  }, 'Only letters, numbers and hyphen allowed');

  $.validator.addMethod('basic_email', function (value, element) {
    const regex = new RegExp(/^(\w+|(\w+[\w.%+-]+\w+)+)@(?:\w+([.-\w]+\w+)?\.)+([a-z]{2,})+$/i);
    const emailaddressVal = $(element).val().trim();
    return regex.test(emailaddressVal);
  });

  const implementCaptcha = () => {
    $.getScript('https://www.google.com/recaptcha/api.js').done(function () {
      if ('grecaptcha' in window) {
        window.grecaptcha.ready(() => {
          $.validator.addMethod('verify_recaptcha', function (value, element) {
            let isValid = false;
            const captchaToken = window.grecaptcha.getResponse();
            if (!captchaToken) return false; // return if captcha is not checked
            const payload = {
              captchaToken
            };
            const request = {
              method: 'POST',
              data: JSON.stringify(payload),
              dataType: 'json',
              contentType: 'application/json',
              url: 'https://alfred.freshworks.com/v1/verify-recaptcha',
              async: false
            };
            $.ajax(request).done(function (response) {
              if (response) { isValid = Boolean(response.success); }
            });
            return isValid;
          });

          $('.recaptcha-form').each(function () {
            $(this).rules('add', {
              verify_recaptcha: true,
              messages: {
                verify_recaptcha: $(this).data('recaptcha-error')
              }
            });
          });
        });
      }
    });
  };

  LocationUtilities.onLocationReady(function (loc, simpleGeoLocation) {
    if (simpleGeoLocation && simpleGeoLocation.countryCode === 'RU') {
      implementCaptcha();
    }
  });

  $.validator.addMethod('zero_bounce_email', function (value, element) {
    try {
      const geoLocation = LocationUtilities.getGeoLocation();
      let isValid = true;

      // skip zero-bounce email validation for events other than submit
      if ($(element).data('onblur-validation-triggered') === true) {
        $(element).data('onblur-validation-triggered', false);
        return isValid;
      }

      const country = (geoLocation && geoLocation.countryName) || '';
      const emailaddressVal = ($(element).val() || '').trim();
      const gaClientID = SiteUtilities.getGAClientID();

      const $form = $(element).closest('form');

      if (!emailaddressVal || SiteUtilities.isGoogleSSO($form) || SiteUtilities.isShopifySignup()) {
        return isValid;
      }

      const payload = {
        pageUrl: window.location.href,
        emailId: emailaddressVal,
        country,
        gaClientID
      };
      const getZeroBounceValidation = {
        method: 'POST',
        data: JSON.stringify(payload),
        dataType: 'json',
        contentType: 'application/json',
        url: 'https://alfred.freshworks.com/v1/email-verification',
        async: false,
        success: function (response) {
          if (!response.error && response.hasOwnProperty('isValid')) {
            isValid = response.isValid;
            const eventLabel = isValid ? `Email Validated <${emailaddressVal}>` : `Error <${emailaddressVal}>`;
            GA4Utilities.postGAEvent(
              'Block Invalid Domains',
              'Normal Signup',
              eventLabel,
              '',
              'Block Invalid Domains'
            );
          }
        },
        error: function () {}
      };

      $.ajax(getZeroBounceValidation);

      return isValid;
    } catch (e) {
      SiteUtilities.log(
        'Failure in Zero Bounce Email Valiation',
        'Error',
        'Form Utilities - zero_bounce_email',
        1,
        e
      );
      return true;
    }
  });

  if ($('.contact-sales-wrapper .recaptcha').length > 0) {
    implementCaptcha();
  }

  $.validator.addMethod('phone', function (value, element) {
    const re = /[^0-9\-+()]/;
    return this.optional(element) || !re.test(value.replace(/^\s*|\s*$/g, ''));
  }, 'Only numbers and hyphen allowed');
  $.validator.addMethod('phone-length', function (value, element) {
    return this.optional(element) || value.length >= 8;
  }, 'number length is too short');
  $.validator.addMethod('countryPhone', function (value, element) {
    const re = /[^0-9+]/;
    return this.optional(element) || !re.test(value.replace(/^\s*|\s*$/g, ''));
  }, 'Only plus and numbers allowed');

  $.validator.addMethod('dots_validate', (value) => { return !RegExp(/\./g).test(value); });
  // $.validator.addMethod('checkbox_validity', function (value, element) {
  //   return $(element).is(':checked');
  // });
  $.validator.addMethod('non_alphabets_validate', (value) => { return RegExp(/^[a-z\sA-Z']*$/).test(value); });
  $.validator.addMethod('website_address', function (value, element) {
    var regex = new RegExp(/(((http(s)?:\/\/)+(www\.)?)?([\w\-./])*(\.[a-zA-Z]{1,3}\/?))[^\s\b\n|]*[^.,;:?!@^$ -]/i);
    var websiteAddress = $(element).val();
    return regex.test(websiteAddress);
  });

  $.validator.addMethod('businessEmailOnly', (value, element) => {
    return SiteUtilities.isBusinessEmail(value, element);
  });

  $.validator.addMethod('htmlinjection', value => {
    return !SiteUtilities.isTextHTML(value);
  });

  $.validator.addMethod('checkbox_validate', function (value, element) {
    return $(`[name=${element.name}]:checkbox:checked`).length > 0;
  });

  $.validator.addMethod('disposableEmailValidation', function (value, element) {
    return !SiteUtilities.isBlockedEmailDomain(value, element);
  });

  $('[data-email-business-only]').each(function () {
    $(this).rules('add', {
      businessEmailOnly: true,
      messages: {
        businessEmailOnly: $(this).data('email-business-only')
      }
    });
  });

  $('[class*="-signupform"] input[name^="email"], [class*="-signup-form"] input[name^="email"]').each(function () {
    $(this).rules('add', {
      disposableEmailValidation: true,
      messages: {
        disposableEmailValidation: 'Business email only'
      }
    });
  });

  $('.form-field [data-zero-bounce-email-invalid], .email-field [data-zero-bounce-email-invalid]').each(function () {
    $(this).rules('add', {
      zero_bounce_email: true,
      messages: {
        zero_bounce_email: $(this).attr('data-zero-bounce-email-invalid')
      }
    });
  });

  $('.gdpr.form-field [data-gdpr-consent-error]').each(function () {
    $(this).rules('add', {
      checkbox_validate: true,
      messages: {
        required: $(this).attr('data-gdpr-consent-error')
      }
    });
  });

  $('[data-html-injection-validate]').each(function () {
    $(this).rules('add', {
      htmlinjection: true,
      messages: {
        htmlinjection: 'Please enter a valid text'
      }
    });
  });

  $('.form-field [data-website-invalid]').each(function () {
    $(this).rules('add', {
      website_address: true,
      messages: {
        website_address: $(this).data('website-invalid')
      }
    });
  });

  $('.form-field [data-signup-domain-min-length]').each(function () {
    $(this).rules('add', {
      minlength: 3,
      messages: {
        minlength: $(this).attr('data-signup-domain-min-length')
      }
    });
  });

  $('.form-field [data-signup-domain-max-length]').each(function () {
    $(this).rules('add', {
      maxlength: 25,
      messages: {
        maxlength: $(this).attr('data-signup-domain-max-length')
      }
    });
  });

  $('.form-field [data-email-required], .email-field [data-email-required]').each(function () {
    $(this).rules('add', {
      required: true,
      basic_email: true,
      messages: {
        required: $(this).attr('data-email-required'),
        basic_email: $(this).attr('data-email-invalid')
      }
    });
  });

  jQuery('#fconnect_shareinfo input[name="signupbtn-fconnect"]').on('click', function () {
    const $form = $(this).closest('form');
    const $email = $form.find("input[name='email']");
    const $fdeskDomainUrl = $form.find("input[name='fdesk-helpdesk']");
    const $fsalesDomainUrl = $form.find("input[name='fsales-helpdesk']");
    const errorTextDomain = $fsalesDomainUrl.attr('data-domain-required-error');
    const errorTextEmail = $email.attr('data-email-required');
    if ($email.val() === null || $email.val() === '') {
      $email.parent().addClass('error');
      const error = `<em id="email-error" class="error">${errorTextEmail}</em>`;
      $email.siblings('.error-wrapper').html(error);
    } else $email.parent().removeClass('error');

    if (($fdeskDomainUrl.val() === null || $fdeskDomainUrl.val() === '') && ($fsalesDomainUrl.val() === null || $fsalesDomainUrl.val() === '')) {
      $fdeskDomainUrl.add($fsalesDomainUrl).parents('.form-field').addClass('error');
      const errorMsg = `<em class="error">${errorTextDomain}</em>`;
      $fsalesDomainUrl.parents('.form-field').find('.error-wrapper').html(errorMsg);
      return false;
    } else {
      $fdeskDomainUrl.add($fsalesDomainUrl).parents('.form-field').removeClass('error');
    }
  });

  $.validator.addMethod('allow_specific_special_characters_only', function (value, element) {
    const allowedSpecialChars = '&!-';
    const regexpCheck = new RegExp(`^[a-zA-Z\\d\\s${allowedSpecialChars}]*$`, 'g');

    return regexpCheck.test(value);
  });

  $('.form-field [data-company-required]').each(function () {
    $(this).rules('add', {
      minlength: 3,
      messages: {
        required: $(this).attr('data-company-required'),
        minlength: $(this).attr('data-company-min-length')
      }
    });
  });

  $('.form-field [data-company-allow-specific-special-chars-only]').each(function () {
    $(this).rules('add', {
      allow_specific_special_characters_only: true,
      messages: {
        allow_specific_special_characters_only: $(this).attr('data-company-allow-specific-special-chars-only')
      }
    });
  });

  $('.form-field [data-signup-domain-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-signup-domain-required')
      }
    });
  });

  $('.form-field [data-domain-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-domain-required')
      }
    });
  });

  $('.form-field [data-phone-invalid]').each(function () {
    $(this).rules('add', {
      phone: true
    });
  });
  $('.form-field [data-phone-custom-invalid]').each(function () {
    $(this).rules('add', {
      countryPhone: true
    });
  });

  /*
  * Have to write customized messages for each field.
  */
  $('.form-field [data-first-name-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-first-name-required')
      }
    });
  });
  $('.form-field [data-last-name-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-last-name-required')
      }
    });
  });
  $('.form-field [data-name-validate]').each(function () {
    $(this).rules('add', {
      dots_validate: true,
      messages: {
        dots_validate: $(this).attr('data-name-validate')
      }
    });
  });
  $('.form-field [data-non-alphabets-validate]').each(function () {
    $(this).rules('add', {
      non_alphabets_validate: true,
      messages: {
        non_alphabets_validate: $(this).attr('data-non-alphabets-validate')
      }
    });
  });
  $('.form-field [data-select-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-select-required') || 'Please select an option'
      }
    });
  });
  $('.form-field [data-employees-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-employees-required')
      }
    });
  });
  $('.form-field [data-department-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-department-required')
      }
    });
  });
  $('.form-field [data-joblevel-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-joblevel-required')
      }
    });
  });
  $('.form-field [data-companyindustry-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-companyindustry-required')
      }
    });
  });
  $('.form-field [data-website-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-website-required')
      }
    });
  });
  $('.form-field [data-select-required-override]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-select-required-override')
      }
    });
  });
  $('.form-field [data-message-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-message-required')
      }
    });
  });
  $('.form-field [data-country-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: 'Please select a country'
      }
    });
  });
  $('.form-field [data-phone-required]').each(function () {
    $(this).rules('add', {
      messages: {
        required: $(this).attr('data-phone-required')
      }
    });
  });
  $('.form-field [data-checkbox-required]').each(function () {
    $(this).rules('add', {
      checkbox_validate: true,
      messages: {
        required: $(this).attr('data-checkbox-required')
      }
    });
  });
  $('.form-field [data-phone-invalid]').each(function () {
    $(this).rules('add', {
      messages: {
        phone: $(this).attr('data-phone-invalid')
      }
    });
  });
  $('.form-field [data-phone-minlength]').each(function () {
    $(this).rules('add', {
      minlength: 8,
      messages: {
        minlength: $(this).attr('data-phone-minlength')
      }
    });
  });

  $('.form-field [data-number-validate]').each(function () {
    $(this).rules('add', {
      phone: false,
      number: true,
      messages: {
        required: $(this).attr('data-number-validate')
      }
    });
  });

  // login form
  jQuery('.forgot-domain-link').on('click', function (event) {
    var $ = jQuery;
    event.preventDefault();
    $('.forgot-domain-form-wrapper').addClass('forgot-domain-form-animation');
    $('.login-form-wrapper').addClass('login-form-animation');
  });

  // Back end error handling in fservice signup
  jQuery('.fservice-signup-form .form-field input[name^="domain-"]').on('change', function () {
    $('.backend-error-wrapper').fadeOut('fast', 'swing');
  });

  // Hidden fields value
  var locationfields;
  LocationUtilities.onLocationReady(function (geoLocation) {
    locationfields = geoLocation;
    $('.country-location-form').val(locationfields.country.names.en);
    $('.continent-location-form').val(locationfields.continent.names.en);
    $('.city-location-form').val(locationfields.city.names.en);
  });

  // Freshchat email exists check
  $.validator.addMethod('fchat_email_exists', function (value, element) {
    var result = false;
    jQuery.ajax({
      url: 'https://web.freshchat.com/app/email/exists?email=' + encodeURIComponent(value),
      dataType: 'json',
      async: false
    }).done((response, status, jqXHR) => {
      if ((jqXHR.status >= 200 && jqXHR.status < 300) || jqXHR.status === 304) {
        result = typeof jqXHR.responseJSON.exists === 'boolean' ? !jqXHR.responseJSON.exists : false;
      }
    });
    return result;
  });

  $('.email-field input.email-fchat').each(function () {
    $(this).rules('add', {
      fchat_email_exists: true,
      messages: {
        fchat_email_exists: 'Sorry, this email address is already associated with an account. Please try signing up with a different email address.'
      }
    });
  });

  $.validator.addMethod('freddy_roi_agent_count_invalid', function (value, element) {
    const issueVolume = $('.issue-volume-field').val() || 5000;
    const minAgentCount = Math.floor(issueVolume / 1000);
    const maxAgentCount = Math.ceil(issueVolume / 500);

    if (minAgentCount <= value && maxAgentCount >= value) return true;

    return false;
  });

  $('.form-field [data-freddy-roi-plan-required]').each(function () {
    $(this).rules('add', {
      required: true,
      messages: {
        required: $(this).attr('data-freddy-roi-plan-required')
      }
    });
  });

  $('.form-field [data-agent-count-required], .form-field [data-agent-count-invalid]').each(function () {
    $(this).rules('add', {
      required: true,
      freddy_roi_agent_count_invalid: true,
      messages: {
        required: $(this).attr('data-agent-count-required'),
        freddy_roi_agent_count_invalid: $(this).attr('data-agent-count-invalid')
      }
    });
  });

  $('.form-field [data-issue-volume-required], .form-field [data-issue-volume-min-invalid]').each(function () {
    // replace ${MIN_VALUE} with {0}, {0} = current min value of the field validation
    const templatedMinErrorMessage = $(this).attr('data-issue-volume-min-invalid').replace(/{MIN_VALUE}/g, '{0}');
    $(this).rules('add', {
      required: true,
      min: 5000,
      messages: {
        required: $(this).attr('data-issue-volume-required'),
        min: $.validator.format(templatedMinErrorMessage)
      }
    });
  });

  $('.custom-checkbox[data-required="true"] input').each(function () {
    $(this).rules('add', {
      required: true,
      minlength: 1,
      messages: {
        required: $(this).parents('.custom-checkbox').data('msg')
      }
    });
  });
};

/**
 * This updateFieldValidation funtion helps to update validation rules of a element dynamically.
 * FormUtilities.updateFieldValidation( '.className' || $jQueryElement , rules);
 */
const updateFieldValidation = (element, rules) => {
  const property = Object.keys(rules).join(' ');
  $(element).each(function () {
    $(this).rules('remove', property);
    $(this).rules('add', rules);
  });
};

/*
* validation function will validate each form across the product.
* errorPlacementName is the input/textarea field's parent name
* where the error messages will append afer that. And submitHandler
* has separate function for each product. It will be called from the
* submitHandler.js
* =======
* usage
* =======
* Freshworks.formUtilities.validation("classname", 'errorPlacementName', Freshworks.submit.somefunctionname)
*/
const validation = (classname, errorPlacementName, submitHandler, checkboxRule) => {
  const formClass = '.' + classname;
  const rules = {};
  if (checkboxRule) {
    checkboxRule.split(',').forEach((i) => {
      rules[i] = {
        required: true
      };
    });
  }

  jQuery(formClass).each(function () {
    const $form = jQuery(this);
    $form.validate({
      rules,
      ignoreTitle: true,
      highlight: function (element) {
        const $element = jQuery(element);
        $element.attr('aria-invalid', 'true').parents('.' + errorPlacementName).addClass('error');
        $element.parent().removeClass('success');
      },
      unhighlight: function (element) {
        const $element = jQuery(element);
        $element.attr('aria-invalid', 'false').parents('.' + errorPlacementName).removeClass('error');
        if ($form.data('validate-on-blur')) {
          // Limit success validation only for the below fields
          if (['first-name', 'last-name', 'email', 'company'].includes($element.attr('name'))) {
            $element.parent().addClass('success');
          }
          if ($element.data('email-business-only')) {
            GA4Utilities.postGAEvent('Block Generic Experiment', 'Normal Signup', 'Email Validated', '', 'Google SSO and Blocking Generic Signup Experiment');
          }
        }
      },
      errorPlacement: function (error, element) {
        // We first check if the element for errorPlacement is a checkbox.
        // If so we append error-wrapper to the checkbox-wrapper or else if the element is a domain field we reach out to the sibling to add the error message else
        // we place erro-wrapper as sibling to the element
        if (jQuery(element).attr('type') === 'checkbox') {
          const $checkboxWrapper = jQuery(element).closest('.checkbox-wrapper');
          $checkboxWrapper.find('.error-wrapper').append(error);
          // Since generic checkboxes don't have 'errorPlacementName', we'll have to identify it using 'custom-checkbox' class
          if ($checkboxWrapper.hasClass('custom-checkbox')) $checkboxWrapper.addClass('error');
        } else if (jQuery(element).hasClass('helpdesk-form')) {
          jQuery(element).closest('.form-field-domain').siblings('.error-wrapper').append(error);
        } else {
          jQuery(element).siblings('.error-wrapper').append(error);
        }
      },
      errorElement: 'em',
      onkeyup: function (element, event) {
        // Reset validation on change. Also ingore tab and shift keys since they're used to focus into the field
        if (![9, 16].includes(event.keyCode)) {
          const $element = jQuery(element);
          $element.attr('aria-invalid', 'false').parents('.' + errorPlacementName).removeClass('error');
          $element.parent().removeClass('success');
        }
      },
      onfocusout: function (element) {
        // Include on change validation to focusout since auto-fill doesn't trigger on change event
        if ($form.data('validate-on-blur')) {
          // skip zero-bounce-email validation
          const $targetElement = $(element).closest('.form-field [data-zero-bounce-email-invalid], .email-field [data-zero-bounce-email-invalid]');
          if ($targetElement.length) {
            $targetElement.data('onblur-validation-triggered', true);
          }

          jQuery(element).valid();
        }
        SiteUtilities.additionalGenericFields(jQuery(element), $form);
      },
      showErrors: function (errorMap, errorList) {
        // Track business only email errors for GA event
        try {
          const businessEmailOnlyError = errorList.find(error => error.method === 'businessEmailOnly');
          if (businessEmailOnlyError) {
            const $element = jQuery(businessEmailOnlyError.element);
            const emailDomain = ($element.val() || '').split('@')[1];
            GA4Utilities.postGAEvent('Block Generic Experiment', 'Normal Signup', `Error: ${emailDomain}`, '', 'Google SSO and Blocking Generic Signup Experiment');
          }
          this.defaultShowErrors();
        } catch (e) {
          console.log(e);
        }
      },
      submitHandler: submitHandler.bind(null, classname)
    });
  });
};

// Function for populating country dropdown
const initCountryDropdown = (element = '.partner-country-list', CountryList) => {
  const populate = list => $(element).html(
    list
      .map(country => `<li role="option" class="option" data-key="${country['alpha-2']}"><span>${country.name}</span></li>`)
      .concat('<li class="option error"><i></i><span>No matches found!</span></li>')
      .join('')
  )
  ;

  if (CountryList) {
    populate(CountryList);
  } else {
    $.getJSON('/static-assets/js/data/country-codes.json', populate);
  }
};

// Function for populating deptment or job level dropdown
const initDeptJobDropdown = (element, value) => {
  const populate = list => $(element).html(
    list
      .map(value => `<option value="${value}">${value}</option>`)
      .join('')
  )
  ;

  if (value) {
    populate(value);
    autoFillDepartmentField(element);
  }
};

const autoFillDepartmentField = (element) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem('form_details'));
    if (userDetails !== null) {
      let keyName = null;
      if ($(element).hasClass('job-level-form')) {
        keyName = 'query-job-level';
      }
      if ($(element).hasClass('department-form')) {
        keyName = 'query-department';
      }
      if ($(element).hasClass('company-industry-form')) {
        keyName = 'query-company-industry';
      }
      if (keyName && $(element).find(`option[value="${userDetails[keyName]}"]`).length && userDetails[keyName].length) {
        $(element).find(`option[value="${userDetails[keyName]}"]`).attr('selected', 'selected');
        $(element).addClass('field-fix').trigger('change').siblings('.form-placeholder').addClass('placeholder-fix');
      }
    }
  } catch (e) {
    SiteUtilities.log(
      'Auto populating form Department fields Fail',
      'Error',
      'Form Utilities - autoFillForms(Department)',
      1,
      e
    );
  }
};

const intEventLocationField = ($element, eventLocationDataset, elementTag) => {
  if (!$element.length) return;

  const { globalJam: { cityRegion = {}, regionCustomfield = {}, slugCity = {} } = {} } = eventLocationDataset || {};
  const $form = $element.closest('form');
  if (!$form.length) return;

  const generateOptionElements = () => {
    let optionElements = '<option value=""></option>';
    Object.keys(cityRegion).forEach((label) => {
      optionElements += `<option data-region="${cityRegion[label]}" value="${label}">${label}</option>`;
    });
    $element.html(optionElements);
  };

  const updateCustomFields = ($customFields, regionDataSet, hasDynamicId, assetIdReference) => {
    $customFields.each(function () {
      const attrName = this.getAttribute('name');
      this.setAttribute('data-custom-value', regionDataSet[attrName] || '');
    });
    if (hasDynamicId) $form.find(`.${assetIdReference}`).val(regionDataSet[assetIdReference] || '');
  };

  const removeCustomField = ($customFields, assetIdReference) => {
    let hasDynamicId = false;
    $customFields.each(function () {
      if (this.getAttribute('name') === assetIdReference) {
        this.remove();
        hasDynamicId = true;
      }
    });
    return hasDynamicId;
  };

  const autoFillSelectTag = () => {
    const $customFields = $form.find('[data-custom-type=event_location_specific]');
    if (!$customFields.length) return;

    const assetIdReference = 'fm-asset-id';
    const hasDynamicId = removeCustomField($customFields, assetIdReference);

    $element.change(function () {
      const regionDataSet = regionCustomfield[$(this).find(':selected').attr('data-region')];
      if (!regionDataSet) return;
      updateCustomFields($customFields, regionDataSet, hasDynamicId, assetIdReference);
    });
  };

  const autoFillInputTag = (cityLabel) => {
    const $customFields = $form.find('[data-custom-type=event_location_specific]');
    const regionDataSet = regionCustomfield[cityRegion[cityLabel] || ''];
    $element.val(cityLabel);

    if (!$customFields.length) return;
    const assetIdReference = 'fm-asset-id';
    const hasDynamicId = removeCustomField($customFields, assetIdReference);

    if (!regionDataSet) return;
    updateCustomFields($customFields, regionDataSet, hasDynamicId, assetIdReference);
  };

  const getCityLabelFromUrl = () => {
    let pathName = window.location.pathname || '';
    const pathLength = pathName.length;
    pathName = pathName.charAt(pathLength - 1) === '/' ? pathName.substring(0, pathLength - 1) : pathName;
    const citySlug = pathName.substring(pathName.lastIndexOf('/') + 1);
    return slugCity[citySlug || ''] || '';
  };

  switch (elementTag) {
    case 'select': {
      generateOptionElements();
      autoFillSelectTag();
      break;
    }
    case 'input': {
      autoFillInputTag(getCityLabelFromUrl());
      break;
    }
  }
};

const toggleByEventRegion = ($element, defaultOption, toggleOptions) => {
  let currentCountry = null;
  let labelRegionMap = {};
  let currentRegion = null;
  if (!toggleOptions || !$element.length) return;
  const toggleSet = toggleOptions.split(',');

  const toggleSection = (activeRegion, $section) => {
    $section.fadeOut(0);
    $section.each(function () {
      if (this.getAttribute('data-tso-content') === activeRegion) $(this).fadeIn('slow');
    });
  };

  const initialzeField = () => {
    currentRegion = (toggleSet.includes(labelRegionMap[currentCountry]) && labelRegionMap[currentCountry]) || defaultOption;
    if (!currentRegion) return;

    const $contentSection = $('[data-tso-content]');
    if ($contentSection.length) {
      $element.change(function () {
        currentRegion = $(this).find(':selected').val();
        if (currentRegion) toggleSection(currentRegion, $contentSection);
      });
    }

    $element.find(`option[value="${currentRegion}"]`).attr('selected', 'selected');
    $element.addClass('field-fix').trigger('change').siblings('.form-placeholder').addClass('placeholder-fix');
  };

  const loadData = () => {
    const dateObject = new Date();
    const key = `?t=${dateObject.getDate()}${dateObject.getMonth()}${dateObject.getFullYear()}${dateObject.getHours()}`;
    $.when(
      $.getJSON(`/static-assets/js/data/department-job-level.json${key}`),
      new Promise(LocationUtilities.onLocationReady)
    ).done(([eventLocationDataset], geoLocation) => {
      const { globalJam: { countryRegion } = {} } = eventLocationDataset || {};
      labelRegionMap = countryRegion || {};
      const { country: { names: { en: countryName } = {} } = {} } = geoLocation || {};
      currentCountry = countryName || null;
    }).always(() => {
      initialzeField();
    });
  };
  loadData();
};

const init = () => {
  UIAnimations();
  FieldValidation();
};

export default { init, validation, updateFieldValidation, initCountryDropdown, initDeptJobDropdown, intEventLocationField, toggleByEventRegion };
